import Decimal from 'decimal.js-light';

import type { AdvancedOrderProvider } from '@/constants/advancedOrder';
import { matchaFees } from '@/constants/matchaFees';

/**
 * Flash platform fee deducted from output on every Definitive order.
 * Documented promotional rate through December 2026:
 * https://flash.definitive.fi/docs/monetizing-your-integration.md
 */
export const DEFINITIVE_PLATFORM_FEE_BPS = 10;

export const ADVANCED_LIMIT_RECEIVE_LABEL = 'You receive (incl. fee)';
export const ADVANCED_TRIGGER_RECEIVE_LABEL = 'Est. at trigger (incl. fee)';

export function getLimitOrderIntegratorFeeBps(isStableToStablePair: boolean): number {
  return isStableToStablePair ? matchaFees.limitOrder.stables : matchaFees.limitOrder.default;
}

export function getDefinitiveOutputFeeBps(isStableToStablePair: boolean): number {
  return getLimitOrderIntegratorFeeBps(isStableToStablePair) + DEFINITIVE_PLATFORM_FEE_BPS;
}

export function getDefinitiveNetReceiveAmount(
  grossDecimal: string,
  isStableToStablePair: boolean,
): string {
  if (grossDecimal === '') return grossDecimal;
  return new Decimal(grossDecimal)
    .mul(10_000 - getDefinitiveOutputFeeBps(isStableToStablePair))
    .div(10_000)
    .toString();
}

export function getAdvancedOrderReceiveRecap({
  provider,
  isTriggerOrder,
  isStableToStablePair,
  grossDecimal,
}: {
  provider: AdvancedOrderProvider | undefined;
  isTriggerOrder: boolean;
  isStableToStablePair: boolean;
  grossDecimal: string;
}): { amount: string; label: string } {
  return {
    label: isTriggerOrder ? ADVANCED_TRIGGER_RECEIVE_LABEL : ADVANCED_LIMIT_RECEIVE_LABEL,
    amount:
      provider === 'definitive'
        ? getDefinitiveNetReceiveAmount(grossDecimal, isStableToStablePair)
        : grossDecimal,
  };
}
